(function(){
var w=window,d=document,r=d.documentElement;
if(w.SPM)return;w.SPM=1;
var mm=function(q){return !!(w.matchMedia&&w.matchMedia(q).matches)};
var reduce=mm('(prefers-reduced-motion: reduce)');
var fine=mm('(hover: hover) and (pointer: fine)');
var design=!!(w.Shopify&&w.Shopify.designMode);
function el(t,c,x){var e=d.createElement(t);if(c)e.className=c;if(x!=null)e.textContent=x;return e}
function clamp(v,a,b){return v<a?a:(v>b?b:v)}
var io=('IntersectionObserver' in w)?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -10% 0px',threshold:0.1}):null;
function watch(n){if(io)io.observe(n);else n.classList.add('in')}

/* 1. intro curtain, once per session */
function intro(){
 if(!r.classList.contains('sp-intro-on'))return 0;
 try{sessionStorage.setItem('sp-intro','1')}catch(e){}
 if(reduce||design){r.classList.remove('sp-intro-on');return 0}
 var o=el('div','sp-intro');o.setAttribute('aria-hidden','true');
 var m=el('div','sp-intro__mark');
 'SUR+'.split('').forEach(function(c,i){var s=el('span','sp-ch');var t=el('span',null,c);t.style.setProperty('--i',i);s.appendChild(t);m.appendChild(s)});
 var l=el('div','sp-intro__line');
 o.appendChild(m);o.appendChild(l);d.body.appendChild(o);
 r.classList.remove('sp-intro-on');
 requestAnimationFrame(function(){o.classList.add('go')});
 setTimeout(function(){o.classList.add('out')},1150);
 setTimeout(function(){o.remove()},2200);
 return 1.25;
}

/* 2. split text: letters for the hero wordmark, words for headings */
function splitLetters(n,delay){
 if(!n||n.dataset.spSplit)return;n.dataset.spSplit='1';
 var txt=n.textContent;n.setAttribute('aria-label',txt);n.textContent='';
 txt.split('').forEach(function(c,i){var s=el('span','sp-ch');s.setAttribute('aria-hidden','true');var t=el('span',null,c);t.style.setProperty('--i',i);s.appendChild(t);n.appendChild(s)});
 n.style.setProperty('--d0',(delay||0)+'s');n.classList.add('sp-split');
 requestAnimationFrame(function(){requestAnimationFrame(function(){n.classList.add('in')})});
}
function splitWords(n){
 if(!n||n.dataset.spSplit||n.children.length)return;n.dataset.spSplit='1';
 var txt=n.textContent.trim();if(!txt)return;n.setAttribute('aria-label',txt);n.textContent='';
 txt.split(/ +/).forEach(function(wd,i){var s=el('span','sp-w');s.setAttribute('aria-hidden','true');var t=el('span',null,wd);t.style.setProperty('--i',i);s.appendChild(t);n.appendChild(s);n.appendChild(d.createTextNode(' '))});
 n.classList.add('sp-words');watch(n);
}

/* 3. custom cursor (desktop) */
var cur=null,dot=null,cx=-100,cy=-100,tx=-100,ty=-100,cs=1,ts=1;
function cursor(){
 if(!fine||reduce||cur)return;
 cur=el('div','sp-cursor');dot=el('div','sp-cursor-dot');cur.setAttribute('aria-hidden','true');dot.setAttribute('aria-hidden','true');
 d.body.appendChild(cur);d.body.appendChild(dot);
 w.addEventListener('pointermove',function(e){tx=e.clientX;ty=e.clientY;if(!r.classList.contains('sp-has-cursor'))r.classList.add('sp-has-cursor');dot.style.transform='translate3d('+tx+'px,'+ty+'px,0)'},{passive:true});
 d.addEventListener('pointerover',function(e){var t=e.target&&e.target.closest&&e.target.closest('a,button,[role=button],input,select,label,summary');ts=t?2.1:1;cur.classList.toggle('is-link',!!t)},{passive:true});
 d.addEventListener('pointerdown',function(){ts=0.7},{passive:true});
 d.addEventListener('pointerup',function(){ts=1},{passive:true});
 d.addEventListener('mouseleave',function(){r.classList.remove('sp-has-cursor')});
}

/* 4. magnetic buttons and 3D tilt (desktop) */
function magnet(){
 if(!fine||reduce)return;
 d.querySelectorAll('.sp-btn,.sp-hero__cta,.sp-wa,.sp-chip,.sp-top').forEach(function(b){
  if(b.dataset.spMg)return;b.dataset.spMg='1';
  b.addEventListener('pointermove',function(e){var q=b.getBoundingClientRect();b.style.translate=((e.clientX-q.left-q.width/2)*0.25).toFixed(1)+'px '+((e.clientY-q.top-q.height/2)*0.35).toFixed(1)+'px'});
  b.addEventListener('pointerleave',function(){b.style.translate=''});
 });
}
function tilt(){
 if(reduce)return;
 d.querySelectorAll('.product-grid > *, .sp-card, .sp-tile, .sp-ccard').forEach(function(c){
  if(c.dataset.spTilt)return;c.dataset.spTilt='1';
  var t=c.classList.contains('sp-tile')||c.classList.contains('sp-ccard')?c:(c.querySelector('[class*=product-card-gallery]')||c.querySelector('.sp-card__img')||c.firstElementChild);
  if(!t)return;t.classList.add('sp-tilt');if(!fine)return;
  var max=c.classList.contains('sp-tile')?5:7;
  c.addEventListener('pointermove',function(e){var q=c.getBoundingClientRect();var px=(e.clientX-q.left)/q.width-0.5,py=(e.clientY-q.top)/q.height-0.5;
   t.style.transform='perspective(900px) rotateX('+(-py*max).toFixed(2)+'deg) rotateY('+(px*max).toFixed(2)+'deg) scale(1.015)';
   t.style.setProperty('--gx',((px+0.5)*100).toFixed(1)+'%');t.style.setProperty('--gy',((py+0.5)*100).toFixed(1)+'%')});
  c.addEventListener('pointerleave',function(){t.style.transform=''});
 });
}

/* 5. click ripple on our buttons */
function ripple(){
 d.addEventListener('pointerdown',function(e){
  var b=e.target&&e.target.closest&&e.target.closest('.sp-btn,.sp-chip,.sp-hero__cta,.sp-tile,.sp-ccard');if(!b)return;
  var q=b.getBoundingClientRect(),s=Math.max(q.width,q.height)*2.2,x=el('span','sp-ripple');
  x.style.width=x.style.height=s+'px';x.style.left=(e.clientX-q.left-s/2)+'px';x.style.top=(e.clientY-q.top-s/2)+'px';
  b.appendChild(x);setTimeout(function(){x.remove()},800);
 },{passive:true});
}

/* 6. back-to-top ring and giant footer wordmark */
var top_=null,ring=null,giant=null,RL=2*Math.PI*20;
function extras(){
 if(!top_){
  top_=el('button','sp-top');top_.type='button';top_.setAttribute('aria-label','Back to top');
  var NS='http://www.w3.org/2000/svg',sv=d.createElementNS(NS,'svg');sv.setAttribute('viewBox','0 0 48 48');sv.setAttribute('aria-hidden','true');
  [['circle','sp-top__bg'],['circle','sp-top__ring'],['path','sp-top__arrow']].forEach(function(a){var n=d.createElementNS(NS,a[0]);n.setAttribute('class',a[1]);if(a[0]==='circle'){n.setAttribute('cx','24');n.setAttribute('cy','24');n.setAttribute('r','20')}else{n.setAttribute('d','M24 31V17M18 23l6-6 6 6')}sv.appendChild(n)});
  top_.appendChild(sv);
  top_.addEventListener('click',function(){w.scrollTo({top:0,behavior:reduce?'auto':'smooth'})});
  d.body.appendChild(top_);ring=top_.querySelector('.sp-top__ring');ring.style.strokeDasharray=RL;ring.style.strokeDashoffset=RL;
 }
 var f=d.querySelector('footer');
 if(f&&!f.querySelector('.sp-giant')){giant=el('div','sp-giant');giant.setAttribute('aria-hidden','true');var g=el('span',null,'SUR+');giant.appendChild(g);f.appendChild(giant)}
 else if(f)giant=f.querySelector('.sp-giant');
}

/* 7. grain on dark sections */
function grain(){
 d.querySelectorAll('.sp-hero,.sp-grade,.sp-join').forEach(function(s){if(s.querySelector(':scope > .sp-grain'))return;var g=el('span','sp-grain');g.setAttribute('aria-hidden','true');s.appendChild(g)});
}

/* 8. images fade in as they load */
function images(){
 d.querySelectorAll('main img').forEach(function(i){
  if(i.dataset.spImg||i.complete)return;i.dataset.spImg='1';i.classList.add('sp-img-wait');
  var done=function(){i.classList.add('sp-img-in')};i.addEventListener('load',done,{once:true});i.addEventListener('error',done,{once:true});
 });
}

/* 9. page transitions */
function transitions(){
 if(design)return;
 d.addEventListener('click',function(e){
  if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
  var a=e.target&&e.target.closest&&e.target.closest('a[href]');if(!a)return;
  if(a.target&&a.target!=='_self')return;if(a.hasAttribute('download'))return;
  var h=a.getAttribute('href');if(!h||h.charAt(0)==='#'||/^(mailto|tel|javascript|sms):/i.test(h))return;
  var u;try{u=new URL(a.href,location.href)}catch(x){return}
  if(u.origin!==location.origin)return;if(u.pathname===location.pathname&&u.search===location.search&&u.hash)return;
  if(a.closest('form'))return;
  if(a.closest('[role=dialog],dialog,cart-drawer-component,.cart-drawer'))return;
  e.preventDefault();r.classList.add('sp-leave');setTimeout(function(){location.href=u.href},260);
 });
 w.addEventListener('pageshow',function(e){r.classList.remove('sp-leave')});
}

/* 11. phones: tilt the phone and the page moves with it (Android), light taps */
var gx=0,gy=0,tgx=0,tgy=0,gyro=false;
function phone(){
 if(fine)return;
 d.addEventListener('click',function(e){var b=e.target&&e.target.closest&&e.target.closest('.sp-btn,.sp-chip,.sp-hero__cta,.sp-tile,.sp-runway__arrow,.sp-rail__dot');if(b){try{navigator.vibrate&&navigator.vibrate(6)}catch(x){}}},{passive:true});
 if(reduce||!('DeviceOrientationEvent' in w))return;
 var base=null;
 w.addEventListener('deviceorientation',function(e){if(e.gamma==null)return;if(!base)base={b:e.beta||0,g:e.gamma||0};
  tgx=clamp(((e.gamma||0)-base.g)/22,-1,1);tgy=clamp(((e.beta||0)-base.b)/22,-1,1);
  base.b+=((e.beta||0)-base.b)*0.004;base.g+=((e.gamma||0)-base.g)*0.004;
  if(!gyro){gyro=true;r.classList.add('sp-gyro','sp-par')}},{passive:true});
}
/* desktop twin of the phone tilt: the mouse moves the same layers */
function mousePar(){
 if(!fine||reduce)return;
 w.addEventListener('pointermove',function(e){tgx=clamp((e.clientX/w.innerWidth-0.5)*2,-1,1);tgy=clamp((e.clientY/w.innerHeight-0.5)*2,-1,1);if(!gyro){gyro=true;r.classList.add('sp-par')}},{passive:true});
}

/* 10. one animation loop for scroll-linked motion */
var lastY=w.scrollY||0,vel=0,marq=null,marqAnim=null,seal=null,tiles=[],grade=null;
function collect(){
 marq=d.querySelector('.sp-marquee');var tr=marq&&marq.querySelector('.sp-marquee__track');
 marqAnim=(tr&&tr.getAnimations)?tr.getAnimations()[0]:null;
 seal=d.querySelector('.sp-seal');grade=d.querySelector('.sp-grade');
 tiles=[].slice.call(d.querySelectorAll('.sp-tile__name'));
}
function loop(){
 var y=w.scrollY||0,vh=w.innerHeight,dy=y-lastY;lastY=y;vel+= (dy-vel)*0.18;
 if(!reduce){
  if(marq){marq.style.transform='skewX('+clamp(-vel*0.25,-7,7).toFixed(2)+'deg)';if(marqAnim)marqAnim.playbackRate=1+clamp(Math.abs(vel)*0.08,0,4)}
  if(seal&&grade){var q=grade.getBoundingClientRect();if(q.bottom>0&&q.top<vh){var p=(vh-q.top)/(vh+q.height);seal.style.transform='rotate('+(p*120-60).toFixed(1)+'deg) scale('+(0.92+p*0.12).toFixed(3)+')'}}
  for(var i=0;i<tiles.length;i++){var b=tiles[i].getBoundingClientRect();if(b.bottom>0&&b.top<vh){tiles[i].style.transform='translate3d(0,'+(((b.top/vh)-0.5)*-22).toFixed(1)+'px,0)'}}
  if(giant){var gq=giant.getBoundingClientRect();if(gq.top<vh){var gp=clamp((vh-gq.top)/(gq.height+vh*0.35),0,1);giant.style.setProperty('--gp',gp.toFixed(3))}}
  if(cur){cx+=(tx-cx)*0.2;cy+=(ty-cy)*0.2;cs+=(ts-cs)*0.18;cur.style.transform='translate3d('+cx.toFixed(1)+'px,'+cy.toFixed(1)+'px,0) scale('+cs.toFixed(3)+')'}
 }
 if(gyro){gx+=(tgx-gx)*0.08;gy+=(tgy-gy)*0.08;r.style.setProperty('--gx',gx.toFixed(3));r.style.setProperty('--gy',gy.toFixed(3))}
 if(top_){var h=r.scrollHeight-vh,pr=h>0?clamp(y/h,0,1):0;ring.style.strokeDashoffset=(RL*(1-pr)).toFixed(1);top_.classList.toggle('show',y>vh*0.8)}
 requestAnimationFrame(loop);
}

function init(){
 var delay=intro();
 splitLetters(d.querySelector('.sp-hero__mark'),delay?delay+0.1:0.15);
 d.querySelectorAll('.sp-head h2,.sp-grade__h,.sp-finder__title,.sp-join__h').forEach(splitWords);
 cursor();magnet();tilt();extras();grain();images();collect();phone();mousePar();
}
function reinit(){d.querySelectorAll('.sp-head h2,.sp-grade__h,.sp-finder__title,.sp-join__h').forEach(splitWords);magnet();tilt();grain();images();collect()}
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',function(){init();requestAnimationFrame(loop)});else{init();requestAnimationFrame(loop)}
ripple();transitions();
d.addEventListener('shopify:section:load',reinit);
var mo=('MutationObserver' in w)?new MutationObserver(function(){clearTimeout(w.__spMo);w.__spMo=setTimeout(function(){magnet();tilt();images()},250)}):null;
if(mo)d.addEventListener('DOMContentLoaded',function(){var m=d.querySelector('main');if(m)mo.observe(m,{childList:true,subtree:true})});
})();
